import type { RouteRecordRaw } from "vue-router";
import authRoutes from "./auth.routes";

const routes: RouteRecordRaw[] = [
  // 🏠 Publiczny layout i strony dostępne bez logowania
  {
    path: "/",
    component: () => import("layouts/PublicLayout.vue"),
    children: [
      {
        path: "",
        name: "welcome",
        component: () => import("pages/WelcomePage.vue"),
      },
      {
        path: "/reset-confirm",
        name: "reset-confirm",
        component: () => import("pages/ResetPasswordConfirm.vue"),
      },

      ...authRoutes, // ✅ login, register itd.
    ],
  },

  // 🔐 Strony z MainLayout – tylko dla zalogowanych
  {
    path: "/",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: () => import("pages/UserDashboard.vue"),
      },
      {
        path: "duties/signup",
        component: () => import("pages/DutiesSignUp.vue"),
      },
      {
        path: "duties/upcoming",
        component: () => import("pages/DutiesUpcoming.vue"),
      },
      {
        path: "duties/mine",
        component: () => import("pages/DutiesMine.vue"),
      },
      {
        path: "duties/unavailable",
        component: () => import("pages/DutiesUnavailable.vue"),
      },
      {
        path: "profile",
        component: () => import("pages/UserProfile.vue"),
      },
      {
        path: "edit-profile",
        component: () => import("pages/EditProfile.vue"),
      },
    ],
  },

  // 🛡️ Panel administratora
  {
    path: "/admin",
    component: () => import("layouts/AdminLayout.vue"),
    children: [
      {
        path: "",
        name: "admin-dashboard",
        component: () => import("pages/AdminDashboard.vue"),
        meta: { requiresAuth: true, adminOnly: true },
      },
      {
        path: "/admin/messages",
        component: () => import("src/pages/admin/AdminMessages.vue"),
        meta: { requiresAuth: true },
      },

      {
        path: "assign-ministries",
        name: "admin-assign-ministries",
        component: () => import("pages/AdminAssignMinistries.vue"),
        meta: { requiresAuth: true, adminOnly: true },
      },
      {
        path: "archived-events",
        name: "admin-archived-events",
        component: () => import("pages/ArchivedEvents.vue"),
        meta: { requiresAuth: true, adminOnly: true },
      },
      {
        path: "events",
        name: "admin-events",
        component: () => import("pages/AdminEventManagement.vue"),
        meta: { requiresAuth: true, adminOnly: true },
      },
      {
        path: "events/add",
        name: "admin-add-event",
        component: () => import("pages/AddEvent.vue"),
        meta: { requiresAuth: true, adminOnly: true },
      },
      {
        path: "users",
        name: "admin-users",
        component: () => import("pages/AdminUserManagement.vue"),
        meta: { requiresAuth: true, adminOnly: true },
      },
      {
        path: "groups",
        name: "admin-groups",
        component: () => import("pages/admin/AdminGroupsPage.vue"),
        meta: { requiresAuth: true, adminOnly: true },
      },
      {
        path: "event-times",
        name: "admin-event-times",
        component: () => import("pages/admin/DefaultEventTimesAdmin.vue"),
        meta: { requiresAuth: true, adminOnly: true },
      },
      {
        path: "events/:id/roles",
        name: "admin-event-roles",
        component: () => import("pages/AdminEventRoles.vue"),
        props: true,
      },
      {
        path: "assignment-stats",
        component: () => import("pages/AdminAssignmentStats.vue"),
      },
    ],
  },

  // ❌ 404 Not Found
  {
    path: "/:catchAll(.*)*",
    component: () => import("pages/ErrorNotFound.vue"),
  },
];

export default routes;
